"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _triangle = _interopRequireDefault(require("cccisd-icons/triangle2"));
var _cccisdDataviz = _interopRequireDefault(require("cccisd-dataviz"));
var _cccisdLaravelReport = require("cccisd-laravel-report");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import IconWarning from 'cccisd-icons/warning2';
var MAIN_CHART = 'Main';
var SUMMARY_CHART = 'Summary';
var DETAILED_CHART = 'Detailed';
var FidelityReport = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(FidelityReport, _React$Component);
  function FidelityReport() {
    var _this;
    _classCallCheck(this, FidelityReport);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FidelityReport, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      currentView: SUMMARY_CHART,
      hiddenView: DETAILED_CHART
    });
    // get average from sessions
    _defineProperty(_assertThisInitialized(_this), "_calcAverageSession", function (sessionType) {
      var sessions = _this.props.sessions;
      var percentage = 0;
      var ignore = 0;
      for (var x = 0; x < sessions.length; x++) {
        if (sessions[x][sessionType]) {
          percentage += +sessions[x][sessionType];
        } else {
          ignore++;
        }
      }
      if (sessions.length === ignore) {
        return 0;
      }
      return Math.round(percentage / (sessions.length - ignore));
    });
    // capitalize the first letter in a given string
    _defineProperty(_assertThisInitialized(_this), "_captializeFirstLetter", function (string) {
      return string[0].toUpperCase() + string.substring(1).toLowerCase();
    });
    // toggle current view for Fidelity Components section
    _defineProperty(_assertThisInitialized(_this), "_toggleView", function () {
      var hold = _this.state.currentView;
      _this.setState({
        currentView: _this.state.hiddenView,
        hiddenView: hold
      });
    });
    // get chart data and type
    _defineProperty(_assertThisInitialized(_this), "_getChartObject", function (dataType, optionsType) {
      var dataTableObj = optionsType === SUMMARY_CHART ? _this._getSummaryTableDataObj(dataType) : _this._getTableDataObj(dataType);
      return {
        chartType: 'LineChart',
        dataTable: dataTableObj,
        options: _this._getChartOptions(optionsType)
      };
    });
    // gets the table object data
    _defineProperty(_assertThisInitialized(_this), "_getTableDataObj", function (scoreType) {
      var _this$props = _this.props,
        reportProps = _this$props.reportProps,
        sessions = _this$props.sessions;
      var goalScore = reportProps.targetLineValue;
      var dataObj = [[_this._captializeFirstLetter(reportProps.timepointLabel), 'Goal', 'Fidelity'], [0, goalScore, null], [sessions.length + 1, goalScore, null]]; // chart padding

      for (var x = 0; x < sessions.length; x++) {
        var value = (0, _isNil2["default"])(sessions[x][scoreType]) ? null : Math.round(sessions[x][scoreType]);
        dataObj.push([sessions[x].xAxisLabel, goalScore, value]);
      }
      return dataObj;
    });
    // gets the table object data for summary charts
    _defineProperty(_assertThisInitialized(_this), "_getSummaryTableDataObj", function (scoreType) {
      var _this$props2 = _this.props,
        reportProps = _this$props2.reportProps,
        sessions = _this$props2.sessions;
      var dataObj = [[_this._captializeFirstLetter(reportProps.timepointLabel), 'Fidelity'],
      // [0, null],
      [sessions.length, null]]; // chart padding

      for (var x = 0; x < sessions.length; x++) {
        var value = (0, _isNil2["default"])(sessions[x][scoreType]) ? null : Math.round(sessions[x][scoreType]);
        dataObj.push([sessions[x].xAxisLabel, value]);
      }
      return dataObj;
    });
    // render DETAILED VIEW charts
    _defineProperty(_assertThisInitialized(_this), "_renderDetailedComponents", function () {
      var reportProps = _this.props.reportProps;
      var subComponents = [];
      reportProps.subComponents.forEach(function (item) {
        if (_this._willShowChart(item.dataPath)) {
          subComponents.push( /*#__PURE__*/_react["default"].createElement("li", {
            key: item.handle
          }, _this._renderDetailedListItem(item, _this._getChartObject(item.dataPath, DETAILED_CHART))));
        }
      });
      return subComponents;
    });
    // render the individual detailed chart
    _defineProperty(_assertThisInitialized(_this), "_renderDetailedListItem", function (chartInfo, chartObj) {
      var _this$props3 = _this.props,
        reportProps = _this$props3.reportProps,
        sessions = _this$props3.sessions;
      var hasSuffix = !(0, _isNil2["default"])(reportProps.scoreSuffix);
      var hasPrefix = !(0, _isNil2["default"])(reportProps.scorePrefix);
      var rangeItems = _this._getRangeItems(_this._calcAverageSession(chartInfo.dataPath));
      return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].infoArea
      }, /*#__PURE__*/_react["default"].createElement("h1", null, chartInfo.label), /*#__PURE__*/_react["default"].createElement("h3", null, chartInfo.description), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].percentArea
      }, /*#__PURE__*/_react["default"].createElement("h2", {
        style: {
          color: rangeItems.color
        }
      }, /*#__PURE__*/_react["default"].createElement("span", null, hasPrefix && /*#__PURE__*/_react["default"].createElement("span", null, reportProps.scorePrefix), _this._calcAverageSession(chartInfo.dataPath), hasSuffix && /*#__PURE__*/_react["default"].createElement("span", null, reportProps.scoreSuffix), !hasPrefix && !hasSuffix && /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].percent
      }, "%")), /*#__PURE__*/_react["default"].createElement("p", null, "Average Across All", /*#__PURE__*/_react["default"].createElement("br", null), _this._captializeFirstLetter(reportProps.timepointLabelPlural))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].comparisonArea
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].comparisonText
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].largeNumber
      }, _this._getNumberOfBenchmarkedTimepoints(sessions, reportProps.targetLineValue, chartInfo.dataPath)), /*#__PURE__*/_react["default"].createElement("span", null, "of"), /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].largeNumber
      }, _this._getNumberOfTotalTimepoints(sessions, chartInfo.dataPath)), ' ', /*#__PURE__*/_react["default"].createElement("span", null, reportProps.timepointLabelPlural.toLowerCase())), /*#__PURE__*/_react["default"].createElement("div", null, "at or above"), /*#__PURE__*/_react["default"].createElement("div", null, "benchmark"))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].detailedChartArea
      }, /*#__PURE__*/_react["default"].createElement(_cccisdDataviz["default"], {
        chartData: chartObj,
        allowEdit: false
      })));
    });
    // get number of finished sessions at or above the benchmark value
    _defineProperty(_assertThisInitialized(_this), "_getNumberOfBenchmarkedTimepoints", function (sessions, benchmark, component) {
      var benchNum = 0;
      for (var x = 0; x < sessions.length; x++) {
        if (sessions[x][component] && sessions[x][component] >= benchmark) {
          benchNum++;
        }
      }
      return benchNum;
    });
    // get total number of finished sessions
    _defineProperty(_assertThisInitialized(_this), "_getNumberOfTotalTimepoints", function (sessions, component) {
      var totalNum = 0;
      for (var x = 0; x < sessions.length; x++) {
        if (sessions[x][component]) {
          totalNum++;
        }
      }
      return totalNum;
    });
    // render SUMMARY VIEW charts
    _defineProperty(_assertThisInitialized(_this), "_renderSummaryComponents", function () {
      var reportProps = _this.props.reportProps;
      return /*#__PURE__*/_react["default"].createElement("ul", {
        className: _style["default"].horzList
      }, reportProps.subComponents.map(function (chart) {
        if (_this._willShowChart(chart.dataPath)) {
          return /*#__PURE__*/_react["default"].createElement("li", {
            key: chart.handle
          }, _this._renderSummaryListItem(chart, _this._getChartObject(chart.dataPath, SUMMARY_CHART)));
        }
        return null;
      }));
    });
    // render the individual summary chart
    _defineProperty(_assertThisInitialized(_this), "_renderSummaryListItem", function (chartInfo, chartObj) {
      var rangeItems = _this._getRangeItems(_this._calcAverageSession(chartInfo.dataPath));
      var reportProps = _this.props.reportProps;
      var hasSuffix = !(0, _isNil2["default"])(reportProps.scoreSuffix);
      var hasPrefix = !(0, _isNil2["default"])(reportProps.scorePrefix);
      return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("h1", null, chartInfo.label), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].summaryLowerArea
      }, /*#__PURE__*/_react["default"].createElement("h2", {
        style: {
          color: rangeItems.color
        }
      }, hasPrefix && /*#__PURE__*/_react["default"].createElement("span", null, reportProps.scorePrefix), _this._calcAverageSession(chartInfo.dataPath), hasSuffix && /*#__PURE__*/_react["default"].createElement("span", null, reportProps.scoreSuffix), !hasPrefix && !hasSuffix && /*#__PURE__*/_react["default"].createElement("span", null, "%")), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdDataviz["default"], {
        chartData: chartObj,
        allowEdit: false
      }))));
    });
    // check for existing data for chart
    _defineProperty(_assertThisInitialized(_this), "_willShowChart", function (chartScoreName) {
      var sessions = _this.props.sessions;
      for (var x = 0; x < sessions.length; x++) {
        if (sessions[x][chartScoreName] !== null && sessions[x][chartScoreName] !== undefined) {
          return true;
        }
      }
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "_getVericalScale", function () {
      var verticalTicks = [];
      var min = +_this.props.reportProps.verticalScaleMin;
      var max = +_this.props.reportProps.verticalScaleMax;
      var interval = +_this.props.reportProps.verticalScaleInterval;
      if (!interval) {
        if (max <= 5) {
          interval = 1;
        } else if (max <= 25 && max > 10) {
          interval = 2;
        } else if (max >= 25 && max < 50) {
          interval = 5;
        } else if (max >= 50 && max < 90) {
          interval = 10;
        } else if (max > 90) {
          interval = 20;
        }
      }
      for (var i = min; i <= max;) {
        verticalTicks.push(i);
        i += interval;
      }
      return verticalTicks;
    });
    // get display options for chart based on passed in type
    _defineProperty(_assertThisInitialized(_this), "_getChartOptions", function (chartTypeToGet) {
      var reportProps = _this.props.reportProps;
      var hasScorePrefix = !(0, _isNil2["default"])(reportProps.scorePrefix);
      var hasScoreSuffix = !(0, _isNil2["default"])(reportProps.scoreSuffix);
      var hasMin = !(0, _isNil2["default"])(reportProps.verticalScaleMin);
      var hasMax = !(0, _isNil2["default"])(reportProps.verticalScaleMax);
      var ticks = [{
        v: 0,
        f: ''
      }, {
        v: 20,
        f: '20%'
      }, {
        v: 40,
        f: '40%'
      }, {
        v: 60,
        f: '60%'
      }, {
        v: 80,
        f: '80%'
      }, {
        v: 100,
        f: '100%'
      }];
      if (hasScorePrefix && !hasScoreSuffix) {
        var prefix = reportProps.scorePrefix;
        ticks = [{
          v: 0,
          f: prefix + ""
        }, {
          v: 20,
          f: prefix + '20'
        }, {
          v: 40,
          f: prefix + '40'
        }, {
          v: 60,
          f: prefix + '60'
        }, {
          v: 80,
          f: prefix + '80'
        }, {
          v: 100,
          f: prefix + '100'
        }];
      } else if (hasScoreSuffix && !hasScorePrefix) {
        var suffix = reportProps.scoreSuffix;
        ticks = [{
          v: 0,
          f: ""
        }, {
          v: 20,
          f: '20' + suffix
        }, {
          v: 40,
          f: '40' + suffix
        }, {
          v: 60,
          f: '60' + suffix
        }, {
          v: 80,
          f: '80' + suffix
        }, {
          v: 100,
          f: '100' + suffix
        }];
      } else if (hasScorePrefix && hasScoreSuffix) {
        var _prefix = reportProps.scorePrefix;
        var _suffix = reportProps.scoreSuffix;
        ticks = [{
          v: 0,
          f: _prefix + ""
        }, {
          v: 20,
          f: _prefix + '20' + _suffix
        }, {
          v: 40,
          f: _prefix + '40' + _suffix
        }, {
          v: 60,
          f: _prefix + '60' + _suffix
        }, {
          v: 80,
          f: _prefix + '80' + _suffix
        }, {
          v: 100,
          f: _prefix + '100' + _suffix
        }];
      }
      if (hasMin && hasMax) {
        var scale = _this._getVericalScale();
        if (scale) {
          var _suffix2 = hasScoreSuffix ? reportProps.scoreSuffix : '';
          var _prefix2 = hasScorePrefix ? reportProps.scorePrefix : '';
          if (!hasScorePrefix && !hasScoreSuffix) {
            ticks = scale.map(function (item) {
              return {
                v: item,
                f: item.toString() + '%'
              };
            });
          } else {
            ticks = scale.map(function (item) {
              return {
                v: item,
                f: _prefix2 + item.toString() + _suffix2
              };
            });
          }
        }
      }
      switch (chartTypeToGet) {
        case MAIN_CHART:
          return {
            legend: {
              position: 'none'
            },
            width: 500,
            // height: 300,
            interpolateNulls: false,
            series: {
              0: {
                color: '#D3E3CB',
                tooltip: false,
                enableInteractivity: false
              },
              1: {
                color: '#65A84B',
                pointSize: 6
              }
            },
            vAxis: {
              gridlines: {
                color: '#D3D3D3'
              },
              minorGridlines: {
                color: 'transparent'
              },
              ticks: ticks,
              title: 'Fidelity',
              titleTextStyle: {
                color: '#999',
                italic: false
              }
            },
            hAxis: {
              gridlines: {
                color: 'transparent'
              },
              ticks: _this._getHorzTicks(),
              title: _this._captializeFirstLetter(reportProps.timepointLabel),
              titleTextStyle: {
                color: '#999',
                italic: false
              }
            }
          };
        case SUMMARY_CHART:
          return {
            legend: {
              position: 'none'
            },
            backgroundColor: 'transparent',
            // width: 150,
            height: 70,
            interpolateNulls: false,
            series: {
              0: {
                color: '#65A84B',
                tooltip: false,
                enableInteractivity: false
              }
            },
            vAxis: {
              baselineColor: '#ccc',
              gridlines: {
                color: '#D3D3D3'
              },
              minorGridlines: {
                color: 'transparent'
              },
              ticks: ticks
            },
            hAxis: {
              baselineColor: '#ccc',
              gridlines: {
                color: 'transparent'
              },
              ticks: _this._getHorzTicks()
            }
          };
        case DETAILED_CHART:
          return {
            legend: {
              position: 'none'
            },
            width: 450,
            height: 180,
            interpolateNulls: false,
            series: {
              0: {
                color: '#D3E3CB',
                tooltip: false,
                enableInteractivity: false
              },
              1: {
                color: '#65A84B',
                pointSize: 6
              }
            },
            vAxis: {
              gridlines: {
                color: '#D3D3D3'
              },
              minorGridlines: {
                color: 'transparent'
              },
              ticks: ticks,
              title: 'Fidelity',
              titleTextStyle: {
                color: '#999',
                italic: false
              }
            },
            hAxis: {
              gridlines: {
                color: 'transparent'
              },
              ticks: _this._getHorzTicks(),
              title: _this._captializeFirstLetter(reportProps.timepointLabel),
              titleTextStyle: {
                color: '#999',
                italic: false
              }
            }
          };
        default:
          return {};
      }
    });
    // get the horizontal (x-axis) ticks for the charts
    _defineProperty(_assertThisInitialized(_this), "_getHorzTicks", function () {
      var sessions = _this.props.sessions;
      var ticksObj = [{
        v: 0,
        f: ''
      }, {
        v: sessions.length,
        f: ''
      }];
      for (var x = 0; x < sessions.length; x++) {
        ticksObj.push(sessions[x].responseSet);
        // ticksObj.push({v: sessions[x].responseSet, f: sessions[x].xAxisLabel});
      }
      return ticksObj;
    });
    // return the correct items based on range
    _defineProperty(_assertThisInitialized(_this), "_getRangeItems", function (value) {
      var reportProps = _this.props.reportProps;
      for (var x = 0; x < reportProps.ranges.length; x++) {
        if (value >= reportProps.ranges[x].min && value <= reportProps.ranges[x].max) {
          return reportProps.ranges[x];
        }
      }

      // return warning icon in black if no range
      return {
        color: '#000',
        icon: {
          name: 'warning2',
          paths: ['M 1009.96 915.76 v 0 l -437.074 -871.112 c -16.742 -29.766 -38.812 -44.648 -60.882 -44.648 s -44.14 14.882 -60.884 44.648 l -437.074 871.112 c -33.486 59.532 -5 108.24 63.304 108.24 h 869.308 c 68.302 0 96.792 -48.708 63.302 -108.24 Z M 512 896 c -35.346 0 -64 -28.654 -64 -64 s 28.654 -64 64 -64 c 35.348 0 64 28.652 64 64 s -28.652 64 -64 64 Z M 576 640 c 0 35.346 -28.654 64 -64 64 s -64 -28.654 -64 -64 v -192 c 0 -35.346 28.654 -64 64 -64 s 64 28.654 64 64 v 192 Z'],
          viewBox: '0 0 1024 1024'
        }
      };
    });
    // render icon from path information
    _defineProperty(_assertThisInitialized(_this), "_renderIconFromPathInfo", function (iconInfo) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "icon"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        width: "100",
        height: "100",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: iconInfo.viewBox,
        style: {
          fill: 'currentColor'
        }
      }, /*#__PURE__*/_react["default"].createElement("g", null, iconInfo.paths.map(function (p) {
        return /*#__PURE__*/_react["default"].createElement("path", {
          key: p,
          d: p
        });
      }))));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderMultipleComments", function (session) {
      if (session) {
        var commentsList = [];
        var hasCommentsList = !(0, _isNil2["default"])(session.commentsList) && !(0, _isEmpty2["default"])(session.commentsList);
        if (hasCommentsList) {
          commentsList = session.commentsList[_this.props.reportProps.commentPath];
        }
        if (!(0, _isEmpty2["default"])(commentsList)) {
          return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].commentInfo
          }, /*#__PURE__*/_react["default"].createElement("h2", null, session.label), /*#__PURE__*/_react["default"].createElement("span", null), /*#__PURE__*/_react["default"].createElement("h3", null, session.date)), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("ul", null, commentsList.map(function (item, i) {
            if (!(0, _isNil2["default"])(item) && item !== '') {
              return /*#__PURE__*/_react["default"].createElement("li", {
                key: i
              }, item);
            }
            return null;
          })));
        }
      }
    });
    // render comment box
    _defineProperty(_assertThisInitialized(_this), "_renderCommentBox", function (session) {
      var comment = session[_this.props.reportProps.commentPath];
      var hasLineBreaks = (0, _includes2["default"])(comment, '\n');
      var splitComment = comment.split('\n');
      if (comment) return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].commentInfo
      }, /*#__PURE__*/_react["default"].createElement("h2", null, session.label), /*#__PURE__*/_react["default"].createElement("span", null), /*#__PURE__*/_react["default"].createElement("h3", null, session.date)), /*#__PURE__*/_react["default"].createElement("hr", null), hasLineBreaks ? splitComment.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("p", null, item);
      }) : /*#__PURE__*/_react["default"].createElement("p", null, session[_this.props.reportProps.commentPath]));
    });
    return _this;
  }
  _createClass(FidelityReport, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        reportProps = _this$props4.reportProps,
        sessions = _this$props4.sessions,
        isReport = _this$props4.isReport;
      var hasParticipantAlias = !(0, _isNil2["default"])(this.props.reportProps.participantAlias);
      var hasScoreSuffix = !(0, _isNil2["default"])(reportProps.scoreSuffix);
      var hasScorePrefix = !(0, _isNil2["default"])(reportProps.scorePrefix);
      var hasMultipleComments = reportProps.multipleComments === true;
      var hasTargetDescription = !(0, _isNil2["default"])(reportProps.targetDescription);
      var triangleOrientation = this.state.currentView === SUMMARY_CHART ? _style["default"].arrowUp : _style["default"].arrowDown;
      var rangeItems = this._getRangeItems(this._calcAverageSession(this.props.reportProps.dataPath));
      var subComponentsDetailed = reportProps.includeSubComponents ? this._renderDetailedComponents() : [];
      var manySubComponents = subComponentsDetailed.length - 4;
      var commentMargin = 0;
      if (manySubComponents > 0) {
        for (var i = 0; i < manySubComponents; i++) {
          commentMargin += 14;
        }
      }
      var emptyChartNum = 0;
      for (var x = 0; x < sessions.length; x++) {
        if ((0, _isNil2["default"])(sessions[x][this.props.reportProps.dataPath])) {
          emptyChartNum++;
        }
      }
      var reportStyle = isReport ? _style["default"].report + ' ' + _style["default"].paginated : _style["default"].report;
      if (emptyChartNum === sessions.length) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: reportStyle
        }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Report, {
          showPagination: isReport
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].toPdf
        }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].reportContentWrapper
        }, this.props.header, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].contentWrapper
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].reportContent
        }, /*#__PURE__*/_react["default"].createElement("h1", null, reportProps.reportTitle), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: reportProps.description
        }))), /*#__PURE__*/_react["default"].createElement("h4", null, "NO FIDELITY DATA")))))));
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: reportStyle
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Report, {
        showPagination: isReport
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].toPdf
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportContentWrapper
      }, this.props.header, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].contentWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportContent
      }, /*#__PURE__*/_react["default"].createElement("h1", null, reportProps.reportTitle), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: reportProps.description
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].chartArea
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].faceContent
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].face,
        style: {
          color: rangeItems.color
        }
      }, this._renderIconFromPathInfo(rangeItems.icon)), /*#__PURE__*/_react["default"].createElement("h1", {
        style: {
          color: rangeItems.color
        }
      }, hasScorePrefix && /*#__PURE__*/_react["default"].createElement("span", null, reportProps.scorePrefix), this._calcAverageSession(this.props.reportProps.dataPath), hasScoreSuffix ? /*#__PURE__*/_react["default"].createElement("span", null, reportProps.scoreSuffix) : /*#__PURE__*/_react["default"].createElement("span", null, "%")), /*#__PURE__*/_react["default"].createElement("p", null, this.props.reportProps.dataInfoText)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].chartContent
      }, /*#__PURE__*/_react["default"].createElement("h1", null, rangeItems.message), hasParticipantAlias && !hasTargetDescription && /*#__PURE__*/_react["default"].createElement("p", null, "Greater treatment fidelity (80%-100%) is associated with better outcomes for", " " + this.props.reportProps.participantAlias, "."), !hasParticipantAlias && !hasTargetDescription && /*#__PURE__*/_react["default"].createElement("p", null, "Greater treatment fidelity (80%-100%) is associated with better outcomes for clients."), hasTargetDescription && /*#__PURE__*/_react["default"].createElement("p", null, reportProps.targetDescription), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].mainChart
      }, /*#__PURE__*/_react["default"].createElement(_cccisdDataviz["default"], {
        chartData: this._getChartObject(this.props.reportProps.dataPath, MAIN_CHART),
        allowEdit: false
      })))))))), this.props.reportProps.includeSubComponents && /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportContentWrapper
      }, isReport && this.props.header, /*#__PURE__*/_react["default"].createElement("div", {
        className: this.state.currentView === 'Detailed' ? _style["default"].altContentWrapper : _style["default"].contentWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].detailsHeader
      }, /*#__PURE__*/_react["default"].createElement("h1", null, "Fidelity Components"), /*#__PURE__*/_react["default"].createElement("a", {
        onClick: this._toggleView.bind(null)
      }, "See ", this.state.hiddenView, " View", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: triangleOrientation
      }, /*#__PURE__*/_react["default"].createElement(_triangle["default"], null)))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].detailsContent
      }, this.state.currentView === DETAILED_CHART && /*#__PURE__*/_react["default"].createElement("ul", {
        className: _style["default"].vertList
      }, !(0, _isEmpty2["default"])(subComponentsDetailed) && subComponentsDetailed.map(function (item) {
        return item;
      })), this.state.currentView === SUMMARY_CHART && this._renderSummaryComponents())))), this.props.reportProps.includeComments && hasMultipleComments && /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportContentWrapper
      }, isReport && this.props.header, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].contentWrapper,
        style: {
          marginTop: this.state.currentView === DETAILED_CHART ? "".concat(commentMargin, "em") : ''
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].commentsArea
      }, /*#__PURE__*/_react["default"].createElement("h1", null, "Comments:"), this.props.sessions.map(function (session) {
        return _this2._renderMultipleComments(session);
      }))))), this.props.reportProps.includeComments && !hasMultipleComments && /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportContentWrapper
      }, isReport && this.props.header, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].contentWrapper,
        style: {
          marginTop: this.state.currentView === DETAILED_CHART ? "".concat(commentMargin, "em") : ''
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].commentsArea
      }, /*#__PURE__*/_react["default"].createElement("h1", null, "Comments"), this.props.sessions.map(function (session, i) {
        if (!(0, _isNil2["default"])(session[_this2.props.reportProps.commentPath]) && session[_this2.props.reportProps.commentPath] !== '') {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: i
          }, _this2._renderCommentBox(session));
        }
        return /*#__PURE__*/_react["default"].createElement("span", {
          key: i
        });
      }))))))));
    }
  }]);
  return FidelityReport;
}(_react["default"].Component);
_defineProperty(FidelityReport, "propTypes", {
  header: _propTypes["default"].node,
  reportProps: _propTypes["default"].object,
  sessions: _propTypes["default"].array,
  isReport: _propTypes["default"].bool
});
_defineProperty(FidelityReport, "defaultProps", {
  isReport: false
});